import { render, staticRenderFns } from "./TheMessagesMenuHeader.vue?vue&type=template&id=f433230e&scoped=true"
import script from "./TheMessagesMenuHeader.vue?vue&type=script&lang=js"
export * from "./TheMessagesMenuHeader.vue?vue&type=script&lang=js"
import style0 from "./TheMessagesMenuHeader.vue?vue&type=style&index=0&id=f433230e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f433230e",
  null
  
)

export default component.exports